import React,{ Component } from 'react';

import './DSIIssues.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import { API_URL } from '../../utils/config';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import CSVTable from '../CSVTable/CSVTable';
import request from '@acri-tools/react-tools/utils/request';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';

interface Props{
}
interface State{
    open_issues?:any
    loading_open_issues: boolean

    closed_issues?:any
    loading_closed_issues: boolean

}

export default class DSIIssues extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            loading_open_issues: false,
            loading_closed_issues: false,
        }
    }

    componentDidMount(){
        this.fetch_open_issues();
        this.fetch_closed_issues();
    }


    fetch_open_issues = async() =>{
        this.setState({ loading_open_issues: true });
        try{
            let res = await request(`${API_URL}/api/user-manager/v1/files/DIS/projects_open_issues.csv`,{
                method: 'get'
            })

            this.setState({ open_issues: res.data });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch_data` });
            // toast_request_error(e);
        }
        finally{
            this.setState({ loading_open_issues:false })
        } 
    }

    fetch_closed_issues = async() =>{
        this.setState({ loading_closed_issues: true });
        try{
            let res = await request(`${API_URL}/api/user-manager/v1/files/DIS/projects_closed_issues.csv`,{
                method: 'get'
            })

            this.setState({ closed_issues: res.data });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch_data` });
            // toast_request_error(e);
        }
        finally{
            this.setState({ loading_closed_issues:false })
        } 
    }

    render(){
        return (
            <div className="dsi-issues">
                <Tabs
                    tabs={[
                        {
                            label: <>Open Issues</>,
                            content: <div className="tab-padding">
                                {
                                    this.state.loading_open_issues ?
                                        <div className="centered">
                                            <Spinner/>
                                        </div>
                                    :
                                    this.state.open_issues &&
                                    <CSVTable
                                        update_filter
                                        parse_options={{
                                            delimiter: ';'
                                        }}
                                        export export_name="projects_open_issues"
                                        data={this.state.open_issues}
                                        sort_columns={{
                                            0: { filter: 'alphabetical' },
                                            1: { filter: 'alphabetical' },
                                            2: { filter: 'alphabetical' },
                                            3: { filter: 'alphabetical' },
                                            4: { filter: 'alphabetical' },
                                            5: { filter: 'alphabetical' },
                                            6: { filter: 'alphabetical' },
                                            7: { filter: 'alphabetical' },
                                        }}
                                    />
                                }
                            </div>
                        },
                        {
                            label: <>Closed Issues</>,
                            content: <div className="tab-padding">
                                {
                                    this.state.loading_closed_issues ?
                                        <div className="centered">
                                            <Spinner/>
                                        </div>
                                    :
                                    this.state.closed_issues &&
                                    <CSVTable
                                        update_filter
                                        parse_options={{
                                            delimiter: ';'
                                        }}
                                        export export_name="projects_closed_issues"
                                        data={this.state.closed_issues}
                                        sort_columns={{
                                            0: { filter: 'alphabetical' },
                                            1: { filter: 'alphabetical' },
                                            2: { filter: 'alphabetical' },
                                            3: { filter: 'alphabetical' },
                                            4: { filter: 'alphabetical' },
                                            5: { filter: 'alphabetical' },
                                            6: { filter: 'alphabetical' },
                                            7: { filter: 'alphabetical' },
                                            8: { filter: 'alphabetical' },
                                        }}
                                    />
                                }
                            </div>
                        }
                    ]}
                />
            </div>
        );
    }
    
};
